import { reject, resolve } from 'core-js/fn/promise'
import axios from '../../axios.js'

function parsePayload(payload, type, status) {
  let search = []
  if (payload['s']) {
    search = payload['s']['$and'] ? payload['s']['$and'] : {}
  } else {
    payload.s = {}
  }
  if (search) payload['s']['$and'] ? (payload['s']['$and'] = search) : {}
  payload.s.status = status
    ? status
    : payload.status
    ? payload.status
    : ['open']
  if (!payload.type) payload.s.type = type

  return payload
}
//
// function parsePayload(payload, type, status) {
//   console.log(
//     `payload ${JSON.stringify(payload)} + type ${JSON.stringify(
//       type
//     )} + status ${JSON.stringify(status)}`
//   )
//   let search = []
//   if (payload['s']) {
//     search = payload['s']['$and'] ? payload['s']['$and'] : {}
//   }
//   search = addTypeToSearch(search, payload, type, status)
//   payload['s'] = { $and: search }
//   return payload
// }
function addTypeToSearch(search, payload, type, status) {
  const recordIndex = search.findIndex((s) => s['type'] !== undefined)
  if (recordIndex >= 0) {
    search.splice(recordIndex, 1)
  }
  payload.s.status = status
    ? status
    : payload.status
    ? payload.status
    : ['open', 'close', 'paid', 'processing']
  if (!payload.type) payload.s.type = type

  return search
}
export default {
  async fetchEInvoiceRecord({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/e-invoices', {
          params: payload,
        })
        .then((response) => {
          commit('SET_EINVOICES', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async fetchFailureCases({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/e-invoices/get-failed-email-cases', {
          params: parsePayload(payload),
        })
        .then((response) => {
          commit('SET_EINVOICES_FAILED_CASES', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async sendMultipleEmails(context, payload) {
    try {
      const response = await axios.post('/e-invoices/send-bulk-emails', {
        bulk: payload,
      })
      if (response.status !== 200) return response
      else return true
    } catch (err) {
      return err
    }
  },
  sendEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/e-invoices/${encodeURIComponent(payload.docNo)}/${
            payload.type
          }/send-email`
        )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async fetchValidDocEmailCount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/e-invoices/email-logs-report', {
          params: payload,
        })
        .then((response) => {
          commit('SET_EINVOICES_EMAIL_COUNT', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async saveRecord(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/e-invoices', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  fetchRecord(context, docNo) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/e-invoices/${encodeURIComponent(docNo)}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchEInvoiceCount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/e-invoices/count', {
          params: payload,
        })
        .then((response) => {
          commit('SET_DASHBOARD_EINVOICE_COUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchTransactionReport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/e-invoices/transaction-report', {
          params: payload,
        })
        .then((response) => {
          commit('SET_TRANSACTION_REPORT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  generateEInvoicePdf(context, doc) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/e-invoices/${encodeURIComponent(doc.eInvoice.docNo)}/${
            doc.eInvoice.type
          }/generate`
        )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPayload(context, doc) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/e-invoices/${encodeURIComponent(
            doc.eInvoice.lhdnEInvoiceUuid
          )}/getPayload`
        )
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async bulkPdfDownload(context, payload) {
    try {
      const response = await axios.post('/e-invoices/bulk-pdf-download', {
        bulk: payload,
      }, {
        responseType: 'blob', // Important for downloading files
      })
      return response
    } catch (error) {
      console.error('[PDF] Failed to download Zipped PDFs:', error)
      throw error
    }
  },
  async submitLhdn(context, payload) {
    try {
      const response = await axios.post('/lhdn-submissions', payload)
      if (response.status !== 200) return response
      else return true
    } catch (err) {
      return err
    }
  },
  /**
   * Submit documents to IRSP (Singapore Peppol / InvoiceNow)
   * 
   * @param {Object} context - Vuex context
   * @param {Object} payload - Submission payload
   * @param {Array<{docNo: string, type: string}>} payload.billingDocs - Array of billing docs with docNo and type
   * @param {string} [payload.destination] - Optional: 'C3C5' (Peppol+IRAS) or 'C5' (IRAS only)
   * @returns {Promise} Response with submission details
   * 
   * API: POST /irsp-submissions
   */
  async submitIrsp(context, payload) {
    try {
      const requestBody = {
        billingDocs: payload.billingDocs || [],
      }
      
      // Only include destination if explicitly provided
      if (payload.destination) {
        requestBody.destination = payload.destination
      }
      
      const response = await axios.post('/irsp-submissions', requestBody)
      return response
    } catch (err) {
      console.error('[IRSP] Failed to create submission:', err)
      throw err
    }
  },
  cancelEInvoice({ commit }, doc) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/e-invoices/${encodeURIComponent(doc.docNo)}/${doc.type}/cancel`,
          {
            reason: doc.reason,
          }
        )
        .then((response) => {
          commit('UPDATE_EINVOICES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  refreshEInvoiceStatus({ commit }, doc) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `/e-invoices/${encodeURIComponent(doc.docNo)}/${doc.type}/refresh`
        )
        .then((response) => {
          commit('UPDATE_EINVOICES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSubmissionsByDocNo(context, { docNo, type }) {
    return axios
      .get(`/e-invoices/${encodeURIComponent(docNo)}/${encodeURIComponent(type)}/submissions`)
      .then((response) => response.data)
  },
}
